import { DLEndorsements } from '../../utils/constants/constants';
import { isCompletelyEmpty, removeEmptyFields, removeEmptyObjects } from "../../utils/data";

const EndorsementsTable = ({ endorsements }) => {
  // Filter out any objects that are effectively empty strings/nulls
  const validEndorsements = endorsements?.filter(e => !isCompletelyEmpty(e));

  if (!validEndorsements || validEndorsements.length === 0) return null;

  return (
    <>
      <th>Endorsements</th>
      <table className="table table-striped table-bordered">
        <thead>
          <tr><th>Value</th></tr>
        </thead>
        <tbody>
          {validEndorsements.map((item, index) => (
            <tr key={index}>
              <td>{DLEndorsements[item.Code] || item.EndorsementText}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default EndorsementsTable;
